import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  IonButton,
  IonInput,
  IonItem,
  IonList,
} from '@ionic/react';
import { getAppError } from '../../utils/messages';
import {uiInputMode} from "../../utils/ui";
import { useToaster } from '../../hooks/useToaster';

type PaymentEditFormProps = {
  name: string;
  setName: (s: string) => void;
  saveCard: () => void;
};

export default function PaymentEditForm({
  name,
  setName,
  saveCard,
}: PaymentEditFormProps) {
  const [t] = useTranslation('global');
  const [present] = useToaster();

  const validateAndSave = () => {
    if (!name) {
      present(getAppError(t('payments.errorname')));
      return;
    }
    saveCard();
  };

  return (
    <>
      <h1 className="h1 pt-2">{t('payments.changecardtitle')}</h1>
      <p className="pt-1 instructions">{t('payments.changecardinfo')}</p>

      <h1 className="h1 pt-3">{t('payments.cardname')}</h1>
      <IonList inset={false} className="ion-no-padding pt-1">
        <IonItem lines="none" className="ion-no-padding">
          <IonInput
            value={name}
            mode={uiInputMode()}
            aria-label={t('payments.entername')!}
            placeholder={t('payments.entername')!}
            onIonInput={(e) => setName(e.detail.value!)}
            type="text"
            fill="outline"
          ></IonInput>
        </IonItem>
      </IonList>

      <div className="pt-3 ion-text-center">
        <IonButton
          className="btn-default btn-wide-80"
          onClick={() => validateAndSave()}
        >
          {t('payments.savecard')}
        </IonButton>
      </div>
    </>
  );
}
